import {utilities} from "../utilities";

class Navigation {
  constructor() {
    // Top Bar Height - Used to calculate fixed positioning when present
    this.topBarHeight = utilities.getHeight('top-bar');

    // Navbar Wrapper - Used to Calculate fixed positioning
    this.navHeight = utilities.getHeight('wrapper-navbar');

    // Total Height of the Navbar Wrapper and Top Bar used for fixed positioning
    this.headerHeight = parseInt(this.topBarHeight) + parseInt(this.navHeight);

    // Main Navigation Container - You can change the ID below and all will still work
    this.navDropdown = document.getElementById('navbar');

    // Used to offset scroll spacing when transitioning from non-fixed to fixed
    this.scrollOffset = 60;

    utilities.setDropdownMenuScrollHeight(this.navDropdown, this.headerHeight, window);
  }

  run() {
    this.setEventListeners();
    utilities.setDropdownMenuScrollHeight(this.navDropdown, this.headerHeight, window);
  }

  setEventListeners() {
    // Scroll Listener for Setting Fixed Navigation
    window.addEventListener('scroll', function() {
      // Ternary Operator for Legacy Browser Support
      const windowPos = (!window.scrollY) ? window.pageYOffset:window.scrollY;

      if (windowPos <= 0) {
        this.setFixedNav(false)
      } else if (windowPos > this.headerHeight + this.scrollOffset) {
        this.setFixedNav(true)
      }
    }.bind(this), false);

    window.addEventListener('load', function() {
      // Ternary Operator for Legacy Browser Support
      const windowPos = (!window.scrollY) ? window.pageYOffset:window.scrollY;

      // Boolean used for setting fixed status on navigation
      const navFixedStatus = (windowPos >= this.headerHeight + this.scrollOffset);

      // Set Navigation status based off boolean calculated above
      this.setFixedNav(navFixedStatus);
    }.bind(this), false);

    window.addEventListener('resize', function() {
      const windowPos = (!window.scrollY) ? window.pageYOffset:window.scrollY;

      this.topBarHeight = utilities.getHeight('top-bar');
      this.navHeight = utilities.getHeight('wrapper-navbar');
      this.headerHeight = parseInt(this.topBarHeight) + parseInt(this.navHeight);

      const navFixedStatus = (windowPos >= this.headerHeight);
      this.setFixedNav(navFixedStatus);

      utilities.setDropdownMenuScrollHeight(this.navDropdown, this.headerHeight, window);
    }.bind(this), false);
  }

  setFixedNav(status) {
    const topBar = document.getElementById('top-bar') ?? document.createElement("span");
    const mainNav = document.getElementById('wrapper-navbar') ?? document.createElement("span");
    const toTop = document.getElementById('to-top') ?? document.createElement("span");
    const adminBar = document.getElementById('wpadminbar') ?? document.createElement("span");


    if (status) {
      mainNav.classList.add('fixed');
      topBar.setAttribute('style','margin-bottom: '+(this.navHeight)+'px');
      toTop.classList.add('active');

      // Check if body has admin bar. If so offset the fixed navigation position
      if (utilities.adminBarPresent() && window.innerWidth > 600) {
        mainNav.style.top = adminBar.offsetHeight+'px';
      } else {
        mainNav.style.top = '0px';
      }
    } else {
      mainNav.classList.remove('fixed');
      topBar.removeAttribute('style');
      toTop.classList.remove('active');

      if (utilities.adminBarPresent()) {
        mainNav.style.top = '0px';
      }
    }
  }
}

const navJS = new Navigation();
navJS.run();